var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4"},[(_vm.$route.name == 'donation' && _vm.loaded)?_c('div',[_c('router-view')],1):_vm._e(),(_vm.$route.name == 'donations')?_c('div',[_c('BaseTable',{attrs:{"table":_vm.table,"loading":!_vm.loaded}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }